import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormError} from 'app/model/FormError';

export class Error extends Component {
    static get propTypes() {
        return {
            errors: PropTypes.arrayOf(PropTypes.instanceOf(FormError)).isRequired,
        };
    }

    render() {
        return (
            <div className="error-container">
                {this.props.errors.map(({content}, i) => (
                    <p key={i} className="error" dangerouslySetInnerHTML={{__html: content}} />
                ))}
            </div>
        );
    }
}
